import logo from './logo.svg';
import './App.css';

import Join from './components/join';
import Home from './components/home';
import Fans from './components/fans';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

// import music from './music/The-Princess.mp3'
// import MusicPlayer from './components/music-player';

import { useEffect, useState } from 'react';
import { database } from "./firebaseConfig2";
import { collection, doc, setDoc, onSnapshot  } from "firebase/firestore"; 
import Buttons from './components/buttons';
import About from './components/about';
// import Chatroom from './components/chatroom';
import Stp from './components/stp';



function App() {
  // var audio = new Audio(music);
  const [width, setWidth] = useState(window.innerWidth) //width of viewport

  const [isLoading, setIsLoading] = useState(true);


  const [positionBg, setPositionBg] = useState({x: -20, y: 0});
  const [bgImgId, setBgImgId] = useState('home-image');

  const [fansList, setFansList] = useState([]);
  const [numCountries, setNumCountries] = useState(0);
  const [numFans, setNumFans] = useState(0);


  window.addEventListener('resize', function(event){
        setWidth(window.innerWidth);
    });


    const bgStyle = {
    // backgroundPosition: positionBg
        transform: `translate(${positionBg.y}px, ${positionBg.x}px)`
  }

  
  //parralax effect
  const handleMouseMove = (event) => {
    let setx = -20 + (event.clientX /60);
    let sety = 0 - (event.clientY / 60);
    // requestAnimationFrame(()=>{
        setPositionBg({x: setx, y: sety});
    // })      
  }

  //change background image
  // let location = useLocation();
  // useEffect(() => {
  //   handleNavigation(location)
  // }, [location]);

  const handleNavigation = (pageName) => {
    if (pageName === 'home'){
      // setBgImgId('home-image');
    }
    if (pageName === 'join'){
      // setBgImgId('join-image');
    }
    if (pageName === 'fans'){
      // setBgImgId('fans-image');
    }
  }

  //pull list of fans from firebase
  useEffect(
    () =>
      onSnapshot(collection(database, "stp_fans"), (snapshot) => {
        snapshot.forEach((doc) => {
          let tempfan = {
            country: doc.data().country,
            email: doc.data().email,
            name: doc.data().name,
            website: doc.data().website,
            princess: doc.data().princess
          }
          setFansList(fansList => [...fansList, tempfan]);
          setIsLoading(false);

          
        });

        }),
    []
  );
  


  return (
    <BrowserRouter>
      <div className='site-wrapper' onMouseMove={handleMouseMove} >
        <div className='main-image' id={bgImgId} /> 
        {/* style={bgStyle} * -- Background parralax effect which caused stuttering for some people/}

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home fansList={fansList} numCountries={numCountries} numFans={numFans} set={numFans}/>} />
        <Route path="/join" element={<Join />} />
        <Route path="/fans" element={<Fans fansList={fansList} numCountries={numCountries} setNumCountries={setNumCountries}  numFans={numFans} set={numFans}/>} />
        <Route path="/codes" element={<Buttons/>} />
        <Route path="/about" element={<About fansList={fansList} numCountries={numCountries} setNumCountries={setNumCountries}  numFans={numFans} set={numFans}/>} />
        <Route path="/stp" element={<Stp fansList={fansList} numCountries={numCountries} setNumCountries={setNumCountries}  numFans={numFans} set={numFans}/>} />
        {/* <Route path="/chatroom" element={<Chatroom fansList={fansList} numCountries={numCountries} setNumCountries={setNumCountries}  numFans={numFans} set={numFans}/>} /> */}


        {/* <Route path="/contact" element={<Contact />} /> */}
      </Routes>
            <div className='link-menu-bg'></div>
            <div className={width <= 900 ? "link-menu-mobile" : "link-menu"}>
                  <Link onClick={() => handleNavigation("home")} to="/"><span className='bullet'>• </span>Home</Link>
                  <Link onClick={() => handleNavigation("about") } to="/about"><span className='bullet'>• </span>About the fanlisting</Link>
                  <Link onClick={() => handleNavigation("stp") } to="/stp"><span className='bullet'>• </span>About the game</Link>
                  <Link onClick={() => handleNavigation("fans") } to="/fans"><span className='bullet'>• </span>Fans</Link>
                  <Link onClick={() => handleNavigation("join")} to="/join"><span className='bullet'>• </span>Join</Link>
                  <Link onClick={() => handleNavigation("codes") } to="/codes"><span className='bullet'>• </span>Codes</Link>
                  {/* <Link onClick={() => handleNavigation("chatroom") } to="/chatroom">• Chatroom</Link> */}

            </div>
            {/* <MusicPlayer audio={audio}/> */}
        </div>
    </BrowserRouter>
  );
}
//DejaVu sans = names
//questions, titles, "this is a love story" = kelmscott roman nf
//princess Amatic SC
//long quiet/evil princess = East Sea Dokdo
export default App;
